import { connect } from 'react-redux'

import PaymentItem from '../components/PaymentItem'
import { deletePaymentAction, updatePaymentAction, fetchPaymentTotalsAction } from '../actions/paymentActions'

const mapStateToProps = (state, props) => {
  return { }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    deletePayment: (id) => dispatch(deletePaymentAction(props.organizationId, props.residentId, id)),
    updatePayment: (payment) => dispatch(updatePaymentAction(props.organizationId, props.residentId, payment))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentItem)
